// ** Redux Imports
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http_auth, http_no_auth, http_file} from "@utils"
import {toast} from "react-toastify"
import {REFRESH_TOKEN} from "../../../utility/Utils"
import * as auth from "../Auth"

export const createThingFoundFile = createAsyncThunk('file/createThingFoundFile', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/file/v1/attachment/thing-upload-save', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const createThingLostFile = createAsyncThunk('file/createThingLostFile', async (query, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/file/v1/attachment/lost-upload-save', null, {
            params: query
        })
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getAttachmentData = createAsyncThunk('file/getAttachmentData', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try { ///registration/v1/thing-attachment/list
        const response = await http_no_auth.post('/registration/v1/thing-attachment/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        // document.location.replace(`${baseURLDownload}file/v1/public/download/${response.data?.data[0]?.uuid}`)
        return response.data?.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getAttachmentDataForHistoryPage = createAsyncThunk('file/getAttachmentDataForHistoryPage', async (data, {
    rejectWithValue,
    dispatch
}) => {
    try {
        const response = await http_auth.post('/file/v1/attachment/list', data)
        if (response.data?.data === null) return rejectWithValue(response.data.message)
        return response.data
    } catch (error) {
        const status = error?.response?.status
        if (status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
        return rejectWithValue(error.message)
    }
})

export const getFileTypes = createAsyncThunk('give/getFileTypes', async (type, {dispatch}) => {
    try {
        const response = await http_auth.get(`/registration/v1/reference/file-types`)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})


export const getAttachmentById = createAsyncThunk('give/getAttachmentById', async (id, {dispatch}) => {
    try {
        const response = await http_file.get(`/file/v1/attachment/download/${id}`)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const downloadFileByPinCode = createAsyncThunk('give/downloadFileByPinCode', async (data, {dispatch}) => {
    try {
        const response = await http_file.post(`/file/v1/public/download`, data)
        return response.data
    } catch (error) {
        if (error.response.status === 401) {
            return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        }
    }
})

export const downloadFileByUUID = createAsyncThunk('give/downloadFileByUUID', async (uuid) => {
    try {
        const response = await http_file.get(`/file/v1/public/download/${uuid}`)
        return response.data
    } catch (error) {
        console.log(error)
        // if (error.response.status === 401) {
        //     return dispatch(auth.handleRefreshLogin({refresh_token: localStorage.getItem(REFRESH_TOKEN)}))
        // }
    }
})


export const getSubRegionsList = createAsyncThunk('filter/getSubRegionsList', async (region_id) => {
    const response = await http_auth.get(`/file/found-things/v1/soato/districts/${region_id}`)
    return response.data
})

export const fileSysSlice = createSlice({
    name: 'fileSys',
    initialState: {
        get_attachment_data: [],
        get_attachment_data_history: [],
        fileTypes: [],

        currentPage: 0,
        totalItem: 0,
        totalPages: 0,
        isLoadingFile: false
    },
    reducers: {},
    extraReducers: {
        [getFileTypes.fulfilled]: (state, action) => {
            state.fileTypes = action.payload?.data
            state.isLoadingFile = false
        },
        [getFileTypes.pending]: (state) => {
            state.isLoadingFile = true
        },
        [getFileTypes.rejected]: (state) => {
            toast.error("Error")
            state.isLoadingFile = false
        },

        [createThingFoundFile.fulfilled]: (state) => {
            state.isLoadingFile = false
        },
        [createThingFoundFile.pending]: (state) => {
            state.isLoadingFile = true
        },
        [createThingFoundFile.rejected]: (state) => {
            toast.error("Error")
            state.isLoadingFile = false
        },

        [getAttachmentData.fulfilled]: (state, actions) => {
            state.get_attachment_data = actions.payload
            state.isLoadingFile = false
        },
        [getAttachmentData.pending]: (state) => {
            state.isLoadingFile = true
        },
        [getAttachmentData.rejected]: (state) => {
            toast.error("Error")
            state.isLoadingFile = false
        },

        [getAttachmentDataForHistoryPage.fulfilled]: (state, actions) => {
            state.get_attachment_data_history = actions.payload?.data
            state.currentPage = actions.payload?.page
            state.countItem = actions.payload?.count
            state.totalCount = actions.payload?.total_count
            state.isLoadingFile = false
        },
        [getAttachmentDataForHistoryPage.pending]: (state) => {
            state.isLoadingFile = true
        },
        [getAttachmentDataForHistoryPage.rejected]: (state) => {
            toast.error("Error")
            state.isLoadingFile = false
        }

    }
})

export const {} = fileSysSlice.actions
export default fileSysSlice.reducer
